<template>
  <v-card class="main-container">
    <v-row class="pl-2" v-if="station_id > 0">
      <v-col>
        <div>
          <v-chip
            label
            class=''
            :color="$mainColor"
            style="color: white;"
            >
              Станция: {{nameBsStation}}
            </v-chip>
        </div>
      </v-col>
      <v-col style="text-align: right;">
        <v-menu
          bottom
          left>
          <template v-slot:activator="{ on }">
            <v-btn small class="mr-4" v-on="on">
              {{"Действия"}}<v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              class="item-menu-text"
              x-small
              @click="export_dialog = true">
              <v-list-item-subtitle>{{ "экспорт календаря" }}</v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col>
        <div style="margin-left: 10px; margin-top: 50px;">
            <v-chip
            label
            class=''
            :color="$mainColor"
            style="color: white;"
            >
              Станция: undefined...
            </v-chip>
        </div>
      </v-col>
    </v-row>

    <v-spacer style="height:10px;"></v-spacer>

    <v-row>
      <v-col>
        <v-expansion-panels
          multiple
          v-model="panels"
        >
          <v-expansion-panel>
            <v-expansion-panel-header>
              <b>
                <v-icon>mdi-clipboard-text</v-icon>
                  Экспертиза: укажите техническую реализуемость эксперимента
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      style="cursor:help;"
                    >
                      <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                    </v-btn>
                  </template>
                  <span>Поданные заявки ожидающие рассмотрения на экспертном совете. Пожалуйста, оцените техническую возможность выполнения этих заявок на вашей станции.</span>
                </v-tooltip>
              </b>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <TechPossibleTable
                    @closeTab="close_tab_techpossible($event)" 
                />



              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <b>
                <v-icon>mdi-calendar-edit-outline</v-icon>
                  Календарь
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      style="cursor:help;"
                    >
                      <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                    </v-btn>
                  </template>
                  <span>Все текущие заявки и календарь станции.</span>
                </v-tooltip>
              </b>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-row class="flex-nowrap">
                  <v-col style="max-width: 450px !important;" class="pt-0 pb-0">
                    <CurrentProposalColList
                      list_name="Активные заявки"
                    />
                  </v-col>
                  <v-col class="pr-8">
                    <calendar-station 
                        :input_station_id="station_id"
                    />
                  </v-col>
                </v-row>
                <v-row style="max-width: 450px;">
                  <v-col>
                      <v-card-text>
                        <v-list class="d-flex align-center justify-start">
                          <v-list-item>
                            <v-tooltip  bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class="red_bg"
                                  @click=""
                                  v-bind="attrs"
                                  v-on="on"
                                  style="cursor:help;"
                                  x-small>
                                    Просрочена
                                </v-btn>
                              </template>
                            <span>Закройте заявку или обратитесь к руководителю для продления доступных дат</span>
                            </v-tooltip>
                          </v-list-item>
                          <v-list-item>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class=""
                                  @click=""
                                  v-bind="attrs"
                                  v-on="on"
                                  x-small
                                  style="cursor:help;"
                                >
                                  Текущая
                                </v-btn>
                              </template>
                              <span>Активная заявка текущей сессии. После выполнения не забудьте закрыть</span>
                            </v-tooltip>
                          </v-list-item>

                          <v-list-item>
                            <v-tooltip  bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class="orange_bg"
                                  @click=""
                                  v-bind="attrs"
                                  v-on="on"
                                  style="cursor:help;"
                                  x-small>
                                    Планирование
                                </v-btn>
                              </template>
                            <span>Заявка следующей экспериментальной сессии. Пожалуйста, распределите ПРЕДВАРИТЕЛЬНОЕ время выполнения.</span>
                            </v-tooltip>
                          </v-list-item>
                        </v-list>
                      </v-card-text>
                  </v-col>
                </v-row>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
                    <v-expansion-panel>
            <v-expansion-panel-header>
              <b>
                <v-icon>mdi-wrench-clock-outline</v-icon>
                  In-house и обслуживание
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      style="cursor:help;"
                    >
                      <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                    </v-btn>
                  </template>
                  <span>In-house и обслуживание</span>
                </v-tooltip>
              </b>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <InHouseTable/>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>
              <b>
                <v-icon>mdi-calendar-expand-horizontal</v-icon>
                  Экспертные советы (Сессии)
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      style="cursor:help;"
                    >
                      <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                    </v-btn>
                  </template>
                  <span>История экспертных советов и заявок по ним</span>
                </v-tooltip>
              </b>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <CouncilTable/>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
<!--  ARCHIVE -->
          <v-expansion-panel>
            <v-expansion-panel-header>
              <b>
                <v-icon>mdi-archive</v-icon>
                  Архив заявок
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      style="cursor:help;"
                    >
                      <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                    </v-btn>
                  </template>
                  <span>Черновики будущих заявок, выполненные и не реализованные заявки.</span>
                </v-tooltip>
              </b>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <div style="margin-top: 40px;" class="lists">
                  <template v-for="(item, index) in allStatusList" >
                    <ListProposalsCommon
                      :status_id="item.status_id"
                      :list_name="item.name"
                    />
                  </template>
                </div>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    
    <v-spacer style="height:10px;"></v-spacer>

  <v-dialog v-model="export_dialog" max-width="40%">
    <v-card>
      <v-card-title class="headline">экспорт календаря
      </v-card-title>
      <v-card-text>выберите период:</v-card-text>

      <!-- <div class="input-container input-name modal-mul-select">
        <v-select
          v-model="silent_new_status"
          :items="silent_new_statuses"
          item-text="name"
          item-value="id"
          outlined
          chips
          required
        ></v-select>
      </div>

      <v-list-item-title class="help-step modal-mul-select">дата смены статуса : </v-list-item-title>
      <div class="input-container input-name modal-mul-select">
        <v-date-picker
          v-model="silent_date"
          :allowed-dates="allowedDates"
          class="mt-4"
          min="2021-01-01"
          max="2028-12-31"
        ></v-date-picker>
      </div>

      <v-card-text>
        <v-text-field
          v-model="dialog_comment"
          outlined
          required
          name="input-7-4"
          :label="$t('comment')"
        ></v-text-field>
      </v-card-text>

      <v-list-item-title>{{$t('file-upload.text')}}</v-list-item-title>
        <v-file-input
            v-model="file"
            label="Добавить файл"
            color="#15336d"
            :success="loadedFile"
            :loading="loadedFile"
            prepend-icon="mdi-paperclip">
          </v-file-input>
-->
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text
          @click="export_station_calendar()">{{"выгрузить"}}
        </v-btn>
        <v-btn color="red darken-1" text @click="export_dialog = false">{{ $t('cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>


  </v-card>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import ListProposalsCommon from '../components/Proposals/list.vue';
import CalendarStation from '../components/Admin/BS/CalendarStation.vue';
import TechPossibleTable from '../components/Admin/BS/TechPossibleTable.vue';
import InHouseTable from '../components/Admin/BS/InHouseTable.vue';
import CouncilTable from '../components/Council/CouncilTable.vue';

import CurrentProposalColList from '../components/Proposals/currentProposalColList.vue';

export default {
  name: 'BS',
  data() {
    return {
      panels: [0,1],

      export_dialog: false,
      experimentListCheckProposal: true,
      color: 'success',
      nameBsStation: '',
      allStatusList: [
        { status_id: 1, slug: 'draft', name: this.$t('ModeratorList.applications_still_being_formed')},
        { status_id: 8, slug: 'need_report', name: this.$t('ModeratorList.awaiting_report')},
        { status_id: 9, slug: 'done', name: this.$t('ModeratorList.completed')},
        { status_id: 10, slug: 'publication', name: this.$t('ModeratorList.there_publication')},
        { status_id: 14, slug:'not_realized', name: this.$t('ModeratorList.not_realized')},
      ],

      station_id: null,
    };
  },
  components: {
    ListProposalsCommon,
    CalendarStation,
    TechPossibleTable,
    CurrentProposalColList,
    InHouseTable,
    CouncilTable,
  },
  async beforeMount() {
    this.GET_EXPER()
    this.station_id = parseInt(this.$route.params.id);

    if(!this.GETTERS_CURRENT_STATION){
      this.SET_CURRENT_STATION(this.station_id);
    }

    this.update_data()
  },
  methods: {
    ...mapActions([
     'GET_EXPER',
     'EXPORT_CALENDAR_EXCEL',
    ]),
    ...mapMutations([
     'SET_CURRENT_STATION',
      'UPDATE_OVERLAY',
    ]),

    close_tab_techpossible(val){
      if(val){
        this.panels.splice(this.panels.indexOf(0),1)
      }
      else{
        if(this.panels.indexOf(0) == -1){
          this.panels.push(0)
        }
      }
    },

    export_station_calendar(){
      this.UPDATE_OVERLAY(true)
      this.EXPORT_CALENDAR_EXCEL({station_id: this.station_id, interval: ''})
        .then((res) => {
          this.UPDATE_OVERLAY(false)
          window.open(res.url, '_blank');
          this.export_dialog = false
        })
        .catch((e) => {
          this.UPDATE_OVERLAY(false)
        });
    },

    update_data(){
      this.nameBsStation = this.GETTERS_CALENDAR_INIT ? this.GETTERS_STATION_BY_ID(this.station_id).name : ''
    },

  },
  computed: {
    ...mapGetters([
      'GETTERS_LOGIN', 
      'GETTERS_CURRENT_STATION',
      'GETTERS_STATION_BY_ID',
      'GETTERS_CALENDAR_INIT',
    ]),
  },

  watch: {
    GETTERS_CURRENT_STATION(val){
      if(val){
        this.station_id = val;
        this.update_data()
      }
    },
    
    GETTERS_CALENDAR_INIT(val) {
        if(val){
          this.update_data()
        }
    },
  }
};
</script>

